import React, { Component } from 'react';
import {
  Alert, Spinner, Table,
} from 'react-bootstrap';
import { PageStatus } from 'enums';
import { Show } from "../../Layout";
import CardHeader from "../Card/CardHeader";
import GridContainer from "../Grid/GridContainer";
import moment from "moment/moment";
import { exportToExcel } from "../../Utils/ExportToExcel";
import { AuthAPI } from "../../API";
import ShowDataAccording2PageSize from '../ShowEntries/ShowEntries';
import PaginationNumbering from '../ShowEntries/Pagination';
import { formatSmartDate } from "../../Utils/DateFormatter";
import { toast } from 'react-toastify';



const MODAL_TYPES = {
  NONE: 'NONE',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  DETAILS: 'DETAILS',
};

type State = {
  status: PageStatus,
  error: string | null,
  formRoType: string,
  data: any[],
  id?: string | null,
  filteredData: any[],
  roFilters: {
    firstName: '',
    email: '',
    phoneNumber: ''
  },
  pageSize: any,
  currentPageNumber: any,
  totalRoResponseData: any,
  totalRoResponsePages: any,
  loading: any,
};

export class RegisteredOnly extends Component<any, State> {
  constructor(props) {
    super(props);
    this.state = {
      status: PageStatus.None,
      error: null,
      formRoType: MODAL_TYPES.NONE,
      data: [],
      id: null,
      filteredData: [],
      roFilters: {
        firstName: '',
        email: '',
        phoneNumber: ''
      },
      pageSize: 10,
      currentPageNumber: 1,
      totalRoResponseData: '',
      totalRoResponsePages: '',
      loading: false,
    };
    this.roFetchList = this.roFetchList.bind(this);
  }

  componentDidMount() {
    this.roFetchList()
  }

  roFetchList(): Promise<void> {
    const { pageSize, currentPageNumber, roFilters } = this.state;
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Loading }))
      .then(() => AuthAPI.usersList(pageSize, currentPageNumber, roFilters, 'registeredOnly'))
      .then((users) => {
        let roResponseData: any = users;
        this.setState({ data: roResponseData.data, filteredData: roResponseData.data, totalRoResponseData: roResponseData.totalCount, totalRoResponsePages: roResponseData.totalPage, status: PageStatus.Loaded });
      })
      .catch((error) => {
        this.setState({ error: error.message, status: PageStatus.Error });
      });
  }

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value)
    this.setState(
      (prevState) => ({
        roFilters: {
          ...prevState.roFilters,
          [name]: value,
        },
      }),
    );
  };

  applyFilters = () => {
    if (this.state.currentPageNumber == 1) { this.roFetchList(); return; }
    this.setState({ currentPageNumber: 1 })
  };


  clearFilter = async () => {
    await new Promise((resolve: any) =>
      this.setState({
        roFilters: {
          firstName: '',
          email: '',
          phoneNumber: ''
        },
        pageSize: 10,
        currentPageNumber: 1,
        totalRoResponseData: '',
        totalRoResponsePages: ''
      }, resolve));
    this.roFetchList();
  }

  async handleRoExport() {
    const { currentPageNumber, roFilters } = this.state;
    this.setState({ loading: true });
    try {
      await AuthAPI.usersList('All', currentPageNumber, roFilters, 'registeredOnly');
      toast.success('Export started! You will receive an email shortly.');
    } catch (error) {
      console.error("Error exporting data:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  handlePageSizeChange = (newRoValue: any) => { this.setState({ pageSize: newRoValue, currentPageNumber: 1 }); };
  handlePageNumberChange = (newRoValue: any) => { this.setState({ currentPageNumber: newRoValue }); };

  componentDidUpdate(prevProps: {}, prevState: State) {
    if (prevState.pageSize !== this.state.pageSize || prevState.currentPageNumber !== this.state.currentPageNumber) { this.roFetchList(); }
  };

  render() {
    const { roFilters, pageSize, currentPageNumber, totalRoResponseData, totalRoResponsePages } = this.state;
    return (
      <>
        <GridContainer>
          <div className='w-100 mb-3'>
            <CardHeader color="primary">
              <div className="d-flex align-items-center justify-content-between">
                <h4>Registered Only Panelists</h4>
              </div>
            </CardHeader>
          </div>
        </GridContainer>

        <div className="jumbotron bg-white p-3 border shadow-sm">
          <div className='mb-3'>Filter</div>

          <form>
            <div className="row">
              <div className="col">
                <label htmlFor='email'>Email</label>
                <input type="text"
                  className="form-control"
                  placeholder="Enter..."
                  name="email"
                  value={roFilters.email}
                  onChange={this.handleFilterChange}
                />
              </div>
              <div className="col">
                <label htmlFor='phoneNumber'>Phone Number</label>
                <input type="text"
                  className="form-control"
                  placeholder="Enter..."
                  name="phoneNumber"
                  value={roFilters.phoneNumber}
                  onChange={this.handleFilterChange}
                />
              </div>
            </div>
          </form>

          <div className="jumbotron bg-white p-1 mt-2 shadow-sm">
            <button type="button" className="btn btn-success" onClick={() => this.applyFilters()}>Filter Panelists</button>
            <button type="button" className="btn btn-info ml-1" onClick={() => this.handleRoExport()}>Export</button>
            <button type="button" className="btn btn-danger ml-1" onClick={() => this.clearFilter()}>Clear Filter</button>
          </div>


        </div>

        <div className="jumbotron bg-white p-3 border shadow-sm">
          <Alert variant="danger" show={this.state.status === PageStatus.Error}>
            {this.state.error}
          </Alert>

          <Show when={this.state.status === PageStatus.Loading}>
            <div className="d-flex justify-content-center w-100 p-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Show>

          <Show when={this.state.status === PageStatus.Loaded}>

            <Show when={!this.state.filteredData.length}>
              <Alert variant="info" show={!this.state.filteredData.length}>
                No data is available
              </Alert>
            </Show>

            <Show when={!!this.state.filteredData.length}>
              <div className='mb-2'>
                <ShowDataAccording2PageSize
                  currentPageSize={pageSize}
                  currentPage={currentPageNumber}
                  sendPageSize={this.handlePageSizeChange}
                  showTotalData={totalRoResponseData}
                  sendLastPage={totalRoResponsePages}
                />
              </div>
              <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '9999' }}>
                {this.state.loading && (
                  <img style={{ height: "415px", }}
                    src="../loadernew.gif"
                    alt="Loading..."
                  />
                )}
              </div>
              <Table responsive size="sm" bordered>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>User Id</th>
                    <th>Email</th>
                    <th>Phone Number</th>
                    <th>CreatedAt</th>
                  </tr>
                </thead>

                <tbody>
                  {
                    this.state.filteredData.map((info, index) => (
                      <tr key={info.id}>
                        <td>{((pageSize) * (currentPageNumber - 1)) + (index + 1)}</td>
                        <td>{info.id}</td>
                        <td>
                          <button
                            className="text-primary bg-transparent"
                            onKeyPress={() => null}
                            onClick={() => {
                              this.setState({
                                formRoType: MODAL_TYPES.NONE,
                                id: info.id,
                              });
                            }}
                            dangerouslySetInnerHTML={{
                              __html: info.email || '-',
                            }}
                          ></button>
                        </td>
                        <td>{info.phoneNumber}</td>
                        <td>{formatSmartDate(info.createdAt)}</td>
                      </tr>
                    ))
                  }
                </tbody>

              </Table>
              <div>
                <PaginationNumbering
                  currentPage={currentPageNumber}
                  returnPagenumber={this.handlePageNumberChange}
                  showTotalData={totalRoResponseData}
                  sendLastPage={totalRoResponsePages}
                />
              </div>
            </Show>
          </Show>
        </div>
      </>
    );
  }
}
